(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6293],{

/***/ 64684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(96116);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');
module.exports = asciiSize;

/***/ }),

/***/ 378:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}
module.exports = asciiToArray;

/***/ }),

/***/ 78461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27117),
  isObjectLike = __webpack_require__(32195);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}
module.exports = baseIsRegExp;

/***/ }),

/***/ 95224:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}
module.exports = baseSlice;

/***/ }),

/***/ 40454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(95224);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

/***/ }),

/***/ 42589:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}
module.exports = hasUnicode;

/***/ }),

/***/ 40731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiSize = __webpack_require__(64684),
  hasUnicode = __webpack_require__(42589),
  unicodeSize = __webpack_require__(91082);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
module.exports = stringSize;

/***/ }),

/***/ 79993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(378),
  hasUnicode = __webpack_require__(42589),
  unicodeToArray = __webpack_require__(20424);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

/***/ }),

/***/ 91082:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = '\\ud83c[\\udffb-\\udfff]',
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
  rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
  rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}
module.exports = unicodeSize;

/***/ }),

/***/ 20424:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = '\\ud83c[\\udffb-\\udfff]',
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
  rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
  rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

/***/ }),

/***/ 96575:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(78461),
  baseUnary = __webpack_require__(8345),
  nodeUtil = __webpack_require__(73651);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
module.exports = isRegExp;

/***/ }),

/***/ 24837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(1375);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
  MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
module.exports = toFinite;

/***/ }),

/***/ 93878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(24837);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

/***/ }),

/***/ 52634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(33734),
  castSlice = __webpack_require__(40454),
  hasUnicode = __webpack_require__(42589),
  isObject = __webpack_require__(23831),
  isRegExp = __webpack_require__(96575),
  stringSize = __webpack_require__(40731),
  stringToArray = __webpack_require__(79993),
  toInteger = __webpack_require__(93878),
  toString = __webpack_require__(41991);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
  DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
    omission = DEFAULT_TRUNC_OMISSION;
  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);
  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += result.length - end;
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
        substring = result;
      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while (match = separator.exec(substring)) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}
module.exports = truncate;

/***/ }),

/***/ 37296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(24782);

/***/ }),

/***/ 65861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]",
      function () {
        return __webpack_require__(65235);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ ThumbnailGrid; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/app/globalStyles.ts
var globalStyles = __webpack_require__(458);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/index.ts
var PageThumbnail = __webpack_require__(12539);
// EXTERNAL MODULE: ./src/classes/plate/Plate.ts + 13 modules
var Plate = __webpack_require__(75696);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/PageThumbnail.tsx + 2 modules
var PageThumbnail_PageThumbnail = __webpack_require__(68644);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
// EXTERNAL MODULE: ./src/components/UI/Tooltip/index.ts + 60 modules
var Tooltip = __webpack_require__(23732);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(30440);
;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/CreationThumbnail.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: 205px; // manual\n  position: relative;\n  border: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  transition-duration: 0.2s;\n  opacity: 0.5;\n  &:hover {\n    opacity: 1;\n  }\n  &:active {\n    opacity: 0.3;\n  }\n\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function CreationThumbnail() {
    var handleClick = function() {
        Plate/* Plate.create */.h.create().then(function(plate) {
            return plate === null || plate === void 0 ? void 0 : plate.open();
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageThumbnail_PageThumbnail/* PreviewWrapper */.q, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            tooltipText: "Create New Plate",
            delayShow: 1000,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCreate, {
                onClick: handleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CreatePage */.Bb, {})
            })
        })
    });
}
var StyledCreate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74c085a9-0"
})(_templateObject(), constants/* DEFAULT_THUMBNAIL_WIDTH */.dg, function(param) {
    var theme = param.theme;
    return "2px solid ".concat(theme.primary);
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.primary);
});

;// CONCATENATED MODULE: ./src/components/Home/PagesThumbnailGrid.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PagesThumbnailGrid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  /* autogen columns with a width of 120px */\n  grid-template-columns: repeat(auto-fit, ",
        "px);\n\n  column-gap: 40px;\n  margin-top: 25px;\n  max-width: 990px;\n  width: 100%;\n\n  @media screen and (max-width: ",
        ") {\n    grid-template-columns: repeat(auto-fit, minmax(",
        "px, 1fr));\n  }\n"
    ]);
    PagesThumbnailGrid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function ThumbnailGrid(param) {
    var plates = param.plates, showCreateOption = param.showCreateOption, _filterValue = param.filterValue, filterValue = _filterValue === void 0 ? "" : _filterValue;
    var filteredPlates = plates.filter(function(plate) {
        return plate.snapshot.title.toLowerCase().includes(filterValue.toLowerCase());
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
        id: "cy-pages-grid",
        children: [
            showCreateOption && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreationThumbnail, {}),
            filteredPlates.map(function(plate) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageThumbnail/* PageThumbnail */.G, {
                    plate: plate,
                    filterValue: filterValue,
                    wrapperStyles: {
                        marginBottom: "25px"
                    },
                    truncateTitle: true
                }, plate.snapshot.id);
            })
        ]
    });
}
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9eed2711-0"
})(PagesThumbnailGrid_templateObject(), constants/* DEFAULT_THUMBNAIL_WIDTH */.dg, globalStyles/* DEVICE.small */.T.small, constants/* DEFAULT_THUMBNAIL_WIDTH */.dg);


/***/ }),

/***/ 15255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EG": function() { return /* binding */ DropZoneIconWrapper; },
/* harmony export */   "OR": function() { return /* binding */ AvatarWrapper; },
/* harmony export */   "Ui": function() { return /* binding */ AvatarDropArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14129);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66420);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  filter: ",
        ";\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  :hover {\n    filter: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  color: black;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  background: ",
        ";\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var AvatarDropArea = function(param) {
    var acceptedFile = param.acceptedFile, getRootProps = param.getRootProps, children = param.children, size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropArea, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        hasAcceptedFile: acceptedFile
    }, getRootProps()), {
        size: size,
        children: children
    }));
};
var AvatarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68b9b1d0-0"
})(_templateObject(), function(param) {
    var brightnessCanChange = param.brightnessCanChange;
    return brightnessCanChange ? "brightness(0.8)" : "";
}, function(param) {
    var brightnessCanChange = param.brightnessCanChange;
    return brightnessCanChange ? "brightness(0.85)" : "";
});
var DropZoneIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68b9b1d0-1"
})(_templateObject1());
var DropArea = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68b9b1d0-2"
})(_templateObject2(), function(props) {
    return props.size ? "".concat(props.size, "px") : "75px";
}, function(props) {
    return props.size ? "".concat(props.size, "px") : "75px";
}, function(props) {
    return props.hasAcceptedFile ? "#f6f6f6" : "#fbfbfb";
});


/***/ }),

/***/ 92405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ StyledForm; },
/* harmony export */   "H2": function() { return /* binding */ H2; }
/* harmony export */ });
/* unused harmony export H3 */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-family: "IBM Plex Mono", monospace;\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 10px;\n  color: ",
        ';\n  font-family: "IBM Plex Mono", monospace;\n  font-weight: 500;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "IBM Plex Mono", monospace;\n  font-size: "24px";\n  font-weight: 600;\n  color: ',
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-14d23675-0"
})(_templateObject());
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-14d23675-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-14d23675-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});


/***/ }),

/***/ 65235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Profile; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(38509);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(89513);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(37296);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(61253);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/classes/api/index.ts + 5 modules
var api = __webpack_require__(54411);
// EXTERNAL MODULE: ./src/components/Layout/LoadingWrapper.tsx + 2 modules
var LoadingWrapper = __webpack_require__(26080);
// EXTERNAL MODULE: ./src/components/Layout/PageLayout.tsx
var PageLayout = __webpack_require__(18057);
;// CONCATENATED MODULE: ./src/components/Profile/types.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ var ProfileTabs;
(function(ProfileTabs) {
    ProfileTabs["PLATES"] = "plates";
    ProfileTabs["FOLLOWING"] = "following";
    ProfileTabs["FOLLOWERS"] = "followers";
})(ProfileTabs || (ProfileTabs = {}));

;// CONCATENATED MODULE: ./src/components/UI/ViennaPill/ViennaPill.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 25px;\n  justify-content: center;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "IBM Plex Mono", monospace;\n  font-size: 12px;\n  line-height: 20px;\n  height: 100%;\n  padding: 0 26px 0 26px;\n  border: ',
        ";\n  display: flex;\n  align-items: center;\n  user-select: none;\n  background-color: ",
        ";\n  color: ",
        ";\n  :first-of-type {\n    border-right-width: 0px;\n  }\n  :last-of-type {\n    border-left-width: 0px;\n  }\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function ViennaPill(param) {
    var tabs = param.tabs, selected = param.selected, setSelected = param.setSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PillWrapper, {
        children: tabs.map(function(param) {
            var label = param.label, slug = param.slug;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PillItem, {
                isSelected: selected === slug,
                onClick: function() {
                    return setSelected(slug);
                },
                children: label
            }, slug);
        })
    });
}
var PillWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dbe9b766-0"
})(_templateObject());
var PillItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dbe9b766-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, function(param) {
    var isSelected = param.isSelected, theme = param.theme;
    return isSelected ? theme.primary : theme.background;
}, function(param) {
    var isSelected = param.isSelected, theme = param.theme;
    return isSelected ? theme.background : theme.text.default;
}, function(param) {
    var isSelected = param.isSelected;
    return !isSelected && "rgba(55, 53, 47, 0.078);";
});

;// CONCATENATED MODULE: ./src/components/Profile/ProfilePill.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function ProfilePill_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  display: flex;\n"
    ]);
    ProfilePill_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function ProfilePill(param) {
    var selected = param.selected, setSelected = param.setSelected;
    var tabs = [
        {
            label: "Plates",
            slug: ProfileTabs.PLATES
        },
        {
            label: "Followers",
            slug: ProfileTabs.FOLLOWERS
        },
        {
            label: "Following",
            slug: ProfileTabs.FOLLOWING
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePill_PillWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViennaPill, {
            tabs: tabs,
            selected: selected,
            setSelected: setSelected
        })
    });
};
var ProfilePill_PillWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fdb78b14-0"
})(ProfilePill_templateObject());

// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/components/UI/Buttons/index.ts
var Buttons = __webpack_require__(75640);
;// CONCATENATED MODULE: ./src/components/Profile/FollowButton.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 





function FollowButton(param) {
    var user = param.user;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var usersFollowedByCurrentUser = currentUser.observe(function(state) {
        return state.following;
    });
    var currentUserIsFollowing = usersFollowedByCurrentUser.some(function(u) {
        return u.snapshot.id === user.snapshot.id;
    });
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var handleFollow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (loading) {
                            _ctx.next = 5;
                            break;
                        }
                        setLoading(true);
                        _ctx.next = 4;
                        return currentUser.follow(user);
                    case 4:
                        setLoading(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollow() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnfollow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (loading) {
                            _ctx.next = 5;
                            break;
                        }
                        setLoading(true);
                        _ctx.next = 4;
                        return currentUser.unfollow(user);
                    case 4:
                        setLoading(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnfollow() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !currentUserIsFollowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* StandardButton */.K3, {
                highContrast: true,
                onClick: handleFollow,
                children: "Follow"
            }),
            currentUserIsFollowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* StandardButton */.K3, {
                onClick: handleUnfollow,
                children: "Following"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/UI/Buttons/StandardButton.tsx
var StandardButton = __webpack_require__(79088);
// EXTERNAL MODULE: ./src/lib/logging/segment.ts
var segment = __webpack_require__(56372);
;// CONCATENATED MODULE: ./src/components/Profile/JoinedMessage.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function JoinedMessage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  margin-top: 10px;\n  /* Mono/Silver Chalice */\n  color: #aeaeae;\n  font-family: "Inter";\n  font-size: 13px;\n'
    ]);
    JoinedMessage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var JoinedMessage = function(param) {
    var user = param.user;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            user.snapshot.registeredWithUrbit ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(JoinedText, {
                children: [
                    user.readableDateJoined,
                    " "
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinedText, {
                children: user.readableDateJoined
            }),
            ((ref = user.snapshot.badges) === null || ref === void 0 ? void 0 : ref.includes("urbit")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(JoinedText, {
                children: [
                    "Signed up with ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Urbit"
                    })
                ]
            })
        ]
    });
};
var JoinedText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20711fc1-0"
})(JoinedMessage_templateObject());

// EXTERNAL MODULE: ./src/components/Shared/User/Avatar.tsx
var Avatar = __webpack_require__(57646);
// EXTERNAL MODULE: ./src/components/Shared/User/Username.tsx + 2 modules
var Username = __webpack_require__(67272);
;// CONCATENATED MODULE: ./src/components/Profile/AvatarAndName.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function AvatarAndName_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  font-size: 24px;\n  font-weight: 700;\n"
    ]);
    AvatarAndName_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AvatarAndName_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AvatarAndName_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function AvatarAndName(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        id: "cy-profile-avatar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                size: 100,
                src: user.avatarURL(100)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                children: user.snapshot.displayName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDetails, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Username/* Username */.R, {
                    user: user
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinedMessage, {
                user: user
            })
        ]
    });
};
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a12f5c8c-0"
})(AvatarAndName_templateObject());
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a12f5c8c-1"
})(AvatarAndName_templateObject1());
var UserDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a12f5c8c-2"
})(_templateObject2());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14129);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(66420);
// EXTERNAL MODULE: ../../node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(62135);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(86093);
// EXTERNAL MODULE: ./src/classes/utilities/FileUtils.ts + 15 modules
var FileUtils = __webpack_require__(56920);
// EXTERNAL MODULE: ./src/components/Profile/AvatarDropArea.tsx
var AvatarDropArea = __webpack_require__(15255);
// EXTERNAL MODULE: ./src/components/UI/Alert/Alert.tsx
var Alert = __webpack_require__(18638);
// EXTERNAL MODULE: ./src/components/UI/Buttons/ButtonPrimitives.tsx
var ButtonPrimitives = __webpack_require__(70854);
// EXTERNAL MODULE: ./src/components/UI/Form/index.ts + 1 modules
var Form = __webpack_require__(49641);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
// EXTERNAL MODULE: ./src/components/UI/Modal/Modal.tsx
var Modal = __webpack_require__(8505);
// EXTERNAL MODULE: ./src/components/UI/Modal/style.ts
var style = __webpack_require__(92405);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(30440);
;// CONCATENATED MODULE: ./src/components/Profile/EditProfile.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




function EditProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "Inter";\n  font-size: 12px;\n  color: #cccccc;\n'
    ]);
    EditProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















function EditProfile(param) {
    var setEditModalOpen = param.setEditModalOpen;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var ref = (0,react.useState)(currentUser.snapshot.bio.length), bioLength = ref[0], setBioLength = ref[1];
    var ref1 = (0,react.useState)(null), avatarFile = ref1[0], setAvatarFile = ref1[1];
    var ref2 = (0,react.useState)(undefined), previewURL = ref2[0], setPreviewURL = ref2[1];
    var ref3 = (0,react.useState)(false), dropRejectedAlertOpen = ref3[0], setDropRejectedAlertOpen = ref3[1];
    var ref4 = (0,react.useState)(currentUser.snapshot.bio), bio = ref4[0], setBio = ref4[1];
    var ref5 = (0,react.useState)(currentUser.snapshot.displayName), displayName = ref5[0], setDisplayName = ref5[1];
    var onDropAccepted = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(acceptedFiles) {
            var file, renamedFile, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = acceptedFiles[0];
                        if (file) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        renamedFile = FileUtils/* FileUtils.renameFile */.P.renameFile(file, (0,v4/* default */.Z)());
                        setAvatarFile(renamedFile);
                        _ctx.next = 7;
                        return FileUtils/* FileUtils.readURLFromFile */.P.readURLFromFile(renamedFile);
                    case 7:
                        url = _ctx.sent;
                        setPreviewURL(url);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(acceptedFiles) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    // hook into dropzone
    var ref6 = (0,es/* useDropzone */.uI)({
        onDropRejected: function() {
            setDropRejectedAlertOpen(true);
        },
        onDropAccepted: onDropAccepted,
        multiple: false,
        accept: {
            "image/*": [
                ".png",
                ".gif",
                ".jpeg",
                ".jpg"
            ]
        }
    }), getRootProps = ref6.getRootProps, getInputProps = ref6.getInputProps;
    var handleBioChange = function(e) {
        var ref;
        setBioLength(((ref = e.target.value) === null || ref === void 0 ? void 0 : ref.length) || 0);
        setBio(e.target.value);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var avatarName;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (currentUser) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        e.preventDefault();
                        avatarName = currentUser.snapshot.avatarName;
                        if (!avatarFile) {
                            _ctx.next = 8;
                            break;
                        }
                        avatarName = avatarFile.name;
                        _ctx.next = 8;
                        return FileUtils/* FileUtils.uploadFile */.P.uploadFile(avatarFile, constants/* AVATAR_BUCKET */.km);
                    case 8:
                        _ctx.next = 10;
                        return currentUser.saveProfileChanges({
                            bio: bio,
                            displayName: displayName,
                            avatarName: avatarName
                        });
                    case 10:
                        setEditModalOpen(false);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        close: function() {
            return setEditModalOpen(false);
        },
        title: "Edit Profile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarDropArea/* AvatarDropArea */.Ui, {
                acceptedFile: !!avatarFile,
                getRootProps: getRootProps,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getInputProps()), {
                        type: "file",
                        name: "file"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarDropArea/* AvatarWrapper */.OR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                            size: 75,
                            src: currentUser.avatarURL(75),
                            previewAvatar: previewURL
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarDropArea/* DropZoneIconWrapper */.EG, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* AddPhotoIcon */.r9, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                        type: "notification",
                        okayText: "OK",
                        onOkay: function() {
                            return setDropRejectedAlertOpen(false);
                        },
                        isOpen: dropRejectedAlertOpen,
                        headerText: "You must upload a single image file"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* StyledForm */.G, {
                style: {
                    marginTop: "20px"
                },
                onSubmit: function(e) {
                    return handleSubmit(e);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style.H2, {
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* EditProfileInput */.Q, {
                        type: "text",
                        maxLength: 35,
                        value: displayName,
                        onChange: function(e) {
                            return setDisplayName(e.target.value);
                        },
                        className: "form-control"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style.H2, {
                        children: "Bio"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* EditProfileInput */.Q, {
                        type: "text",
                        maxLength: 140,
                        value: bio,
                        onChange: handleBioChange,
                        className: "form-control",
                        style: {
                            marginBottom: "5px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLength, {
                        children: "".concat(bioLength, " / 140")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimitives/* Button */.zx, {
                        as: "input",
                        style: {
                            marginTop: "20px",
                            marginBottom: "40px"
                        },
                        type: "submit",
                        value: "Save Changes"
                    })
                ]
            })
        ]
    });
};
var BioLength = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-20cf4247-0"
})(EditProfile_templateObject());

;// CONCATENATED MODULE: ./src/components/Profile/UserInfo.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function UserInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: flex-start;\n  font-family: "Inter";\n  color: ',
        ";\n"
    ]);
    UserInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n"
    ]);
    UserInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserInfo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "IBM Plex Mono";\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 10px;\n'
    ]);
    UserInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









function UserInfo(param) {
    var user = param.user;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var ref = (0,react.useState)(false), isEditing = ref[0], setIsEditing = ref[1];
    var isSelf = user.snapshot.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.snapshot.id);
    var handleEdit = function() {
        setIsEditing(true);
        (0,segment/* safeSegmentTrack */.ed)({
            event: "Edit Profile Modal Opened"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isEditing && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProfile, {
                setEditModalOpen: setIsEditing
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarAndName, {
                                user: user
                            }),
                            currentUser && (isSelf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardButton/* StandardButton */.K, {
                                onClick: handleEdit,
                                children: "Edit Profile"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowButton, {
                                user: user
                            }))
                        ]
                    }),
                    user.snapshot.bio && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bio, {
                        children: [
                            " >",
                            " ",
                            user.snapshot.bio
                        ]
                    })
                ]
            })
        ]
    });
}
var UserInfo_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57ac6cdd-0"
})(UserInfo_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var Actions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57ac6cdd-1"
})(UserInfo_templateObject1());
var Bio = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57ac6cdd-2"
})(UserInfo_templateObject2());

// EXTERNAL MODULE: ./src/components/UI/Links/Links.tsx
var Links = __webpack_require__(50398);
;// CONCATENATED MODULE: ./src/components/User/SuggestedUser.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SuggestedUser_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 15px;\n  flex-grow: 1;\n  user-select: none;\n  color: ",
        ";\n"
    ]);
    SuggestedUser_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestedUser_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  font-family: "Inter", sans-serif;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  width: 320px;\n'
    ]);
    SuggestedUser_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








function SuggestedUserSmall(param) {
    var user = param.user;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* UnstyledLink */.Ho, {
        href: user.inAppLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidePanelItemWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                    src: user.avatarURL(48),
                    size: 48
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfoContainer, {
                    children: [
                        user.snapshot.displayName,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Username/* Username */.R, {
                            hoverable: true,
                            user: user
                        })
                    ]
                }),
                currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        alignSelf: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowButton, {
                        user: user
                    })
                })
            ]
        }, user.snapshot.username)
    });
}
var UserInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69e08be1-0"
})(SuggestedUser_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var SidePanelItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69e08be1-1"
})(SuggestedUser_templateObject1());

;// CONCATENATED MODULE: ./src/components/Profile/UserList.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function UserList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  align-content: flex-start;\n  width: 100%;\n"
    ]);
    UserList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function UserList(param) {
    var users = param.users;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserList_Wrapper, {
        children: users.map(function(user) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedUserSmall, {
                user: user
            }, user.snapshot.id);
        })
    });
};
var UserList_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98bba8d2-0"
})(UserList_templateObject());

// EXTERNAL MODULE: ./src/components/Home/PagesThumbnailGrid.tsx + 1 modules
var PagesThumbnailGrid = __webpack_require__(4454);
;// CONCATENATED MODULE: ./src/components/Profile/UserPlates.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function UserPlates(param) {
    var user = param.user;
    var plates = user.observe(function(state) {
        return state.plates;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PagesThumbnailGrid/* ThumbnailGrid */.y, {
        plates: plates
    });
};

// EXTERNAL MODULE: ./src/components/UI/NoSSR/NoSSR.tsx
var NoSSR = __webpack_require__(7615);
// EXTERNAL MODULE: ./src/lib/types.ts
var types = __webpack_require__(45085);
;// CONCATENATED MODULE: ./src/pages/user/[username].tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function _username_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    _username_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _username_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 25px 25px 0 25px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  max-width: 990px;\n"
    ]);
    _username_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















function Profile() {
    var ref;
    var router = (0,next_router.useRouter)();
    var username = (ref = router.query) === null || ref === void 0 ? void 0 : ref.username;
    var ref1 = (0,react.useState)(null), user = ref1[0], setUser = ref1[1];
    var ref2 = (0,react.useState)(types/* LoadingStatus.Idle */.Q.Idle), loadingStatus = ref2[0], setLoadingStatus = ref2[1];
    var ref3 = (0,react.useState)(ProfileTabs.PLATES), selected = ref3[0], setSelected = ref3[1];
    (0,react.useEffect)(function() {
        var load = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var profile;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoadingStatus(types/* LoadingStatus.Loading */.Q.Loading);
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return api/* API.users.get */.b.users.get(username);
                        case 4:
                            profile = _ctx.sent;
                            _ctx.next = 7;
                            return profile.getPlates();
                        case 7:
                            setUser(profile);
                            setSelected(ProfileTabs.PLATES);
                            setLoadingStatus(types/* LoadingStatus.Succeeded */.Q.Succeeded);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](1);
                            setLoadingStatus(types/* LoadingStatus.Failed */.Q.Failed);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        12
                    ]
                ]);
            }));
            return function load() {
                return _ref.apply(this, arguments);
            };
        }();
        if (router.isReady) {
            load();
        }
    }, [
        router.isReady,
        username
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSSR/* NoSSR */.r, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "@",
                        username,
                        "'s Profile"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* PageWrapper */.FE, {
                id: "pageContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper/* LoadingWrapper */.u, {
                    status: loadingStatus,
                    loadingType: LoadingWrapper/* LoadingType.Fullscreen */.F.Fullscreen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* ScrollContainer */.l$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo, {
                                    user: user
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePill, {
                                    selected: selected,
                                    setSelected: setSelected
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                    children: selected === ProfileTabs.PLATES ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPlates, {
                                        user: user
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserList, {
                                        users: selected === ProfileTabs.FOLLOWERS ? user.snapshot.followers : user.snapshot.following
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var StyledBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf9a995f-0"
})(_username_templateObject());
var ProfileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf9a995f-1"
})(_username_templateObject1());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7599,9281,2135,2539,9774,2888,179], function() { return __webpack_exec__(65861); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);